import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { MainLogoPressable } from '../main-logo-pressable/MainLogoPressable';
import Spinner from '../spinner/Spinner';
import { useUploadScreenLogic } from './UploadScreen.logic';
import { UploadScreenProps } from './UploadScreen.types';
import { TestIDs } from 'src/constants/testIDs.constants';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';

export const UploadScreen = observer((props: UploadScreenProps) => {
  const {
    style,
    corruptedFiles,
    isLoading,
    progress,
    Component,
    onPressRedirectToPhotosiCta,
    onPressRetryCallback,
    onPressUpload,
    config,
  } = useUploadScreenLogic(props);

  return (
    <View style={style.page}>
      <View style={style.header}>
        <MainLogoPressable
          testID={TestIDs.PHOTOSI_LOGO}
          focusId={TestIDs.PHOTOSI_LOGO}
          focusOrder={0}
          focusGroup={FocusGroups.HEADER}
        />
      </View>
      <View style={style.body}>
        <View style={style.container}>
          {isLoading ? (
            <Spinner />
          ) : (
            <Component
              onPressRetry={onPressRetryCallback}
              onPressUpload={onPressUpload}
              onPressRedirectToPhotosiCta={onPressRedirectToPhotosiCta}
              progress={progress}
              corruptedFiles={corruptedFiles}
              style={style}
              {...config}
            />
          )}
        </View>
      </View>
    </View>
  );
});
